/**
 * Безопасный декод JWT payload (base64url + utf-8).
 * Возвращает объект payload или null.
 */
export const decodeJwtPayload = (token) => {
  try {
    const parts = String(token || '').split('.');
    if (parts.length < 2 || !parts[1]) return null;

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    const paddedBase64 = `${base64}${padding}`;

    const binary = atob(paddedBase64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const jsonPayload = new TextDecoder('utf-8').decode(bytes);
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

